import './LoggedOut.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from '../Base/NavBar'
import LoginForm from './LoginForm/LoginForm';
import SignupForm from './SignupForm/SignupForm';
import FindAccountForm from './FindAccountForm/FindAccountForm';
import PrivatePolicy from './PrivatePolicy/PrivatePolicy';
import TermsOfService from './TermsOfService/TermsOfService';

function LoggedOut() {
    return <div>
        <BrowserRouter>
            <NavBar></NavBar>
            <div className="safe-area">
                <Routes>
                    <Route path="/" element={<LoginForm />} />
                    <Route path="/signup" element={<SignupForm />} />
                    <Route path="/find-account" element={<FindAccountForm />} />
                    <Route path="/privacy-policy" element={<PrivatePolicy />} />
                    <Route path="/terms-of-service" element={<TermsOfService />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </div>
        </BrowserRouter>
    </div>
}
export default LoggedOut;